<template>
  <div class="target-package">
    <p class="level-1">定向人群</p>
    <p class="level-2">
      定向设置<el-popover placement="top" trigger="hover" width="300">
        <p style="font-size: 12px; line-height: 1.8">
          支持将当前的定向选择一键保存为定向包，方便未来直接复用，也可以从已创建的定向包中选择
        </p>
        <i class="el-icon-question" slot="reference"></i>
      </el-popover>
    </p>
    <el-radio-group v-model="form.audience.directionalType" size="medium">
      <el-radio-button label="新建定向"></el-radio-button>
      <el-radio-button label="已有定向包" disabled></el-radio-button>
    </el-radio-group>

    <custom-audience :form="form" :isLive="true" :showInterest="true" />

    <p class="level-2">
      更多人群<el-popover placement="top" trigger="hover">
        <p style="font-size: 12px; line-height: 1.8">
          定向：广告将在选定人群包的人群范围内进行展现
        </p>
        <p style="font-size: 12px; line-height: 1.8">
          排除：广告将不对该人群包内的人群进行展现
        </p>
        <i class="el-icon-question" slot="reference"></i>
      </el-popover>
    </p>
    <el-radio-group v-model="form.audience.morePopulation" size="medium">
      <el-radio-button label="不限"></el-radio-button>
      <el-radio-button label="更多人群" disabled></el-radio-button>
    </el-radio-group>

    <div>
      <p class="level-2">
        智能放量<el-popover placement="top" trigger="hover" width="300">
          <p style="font-size: 12px; line-height: 1.8">
            智能放量可以帮你逐步探索已选定向人群之外的目标人群，提升跑量。已选择定向建议放开
          </p>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </p>
      <el-radio-group v-model="form.audience.autoExtend" size="medium">
        <el-radio-button label="不启用"></el-radio-button>
        <el-radio-button label="开启"></el-radio-button>
      </el-radio-group>

      <div class="s-container" v-show="form.audience.autoExtend == '开启'">
        <div class="panel panel-left">
          <div class="panel-header">可开放定向</div>
          <div class="panel-container">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <el-checkbox-group
              v-model="form.audience.extendArr"
              @change="handleCheckedChange"
            >
              <el-checkbox v-for="item in list" :label="item" :key="item">{{
                item
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="panel panel-right">
          <div class="panel-header">
            已选<span
              class="clear"
              v-if="form.audience.extendArr.length > 0"
              @click="
                form.audience.extendArr = [];
                checkAll = false;
                isIndeterminate = false;
              "
              >清空</span
            >
          </div>
          <div class="panel-container">
            <div class="panel-none" v-if="form.audience.extendArr.length == 0">
              <el-image
                class="img"
                :src="require(`@/assets/images/simulation/icon_empty.svg`)"
                fit="fit"
              ></el-image>
            </div>
            <div v-else>
              <div
                class="item-selected"
                v-for="(item, idx) in form.audience.extendArr"
                :key="idx"
              >
                <span class="item-name">{{ item }}</span>
                <i class="el-icon-close" @click="handleDelItem(item)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="save-directional">
      <div class="s-btn">
        <i class="el-icon-circle-plus"></i>
        保存定向
      </div>
      <p>所选标签组合保存为定向包，方便您进行重复使用</p>
    </div>

    <right-card :form="form" :showOther="true" :isStandard="true" />
  </div>
</template>

<script>
import customAudience from "./customAudience.vue";
import RightCard from "./rightCard.vue";
export default {
  components: { customAudience, RightCard },
  props: {
    form: Object,
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      list: ["地域", "性别", "年龄", "行为兴趣", "更多人群-自定义人群"],
    };
  },
  methods: {
    handleCheckAllChange(val) {
      this.form.audience.extendArr = val ? this.list : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.list.length;
    },
  },
};
</script>

<style lang="less" scoped>
.target-package {
  position: relative;
  margin-top: 56px;
  margin-bottom: 56px;
  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 5px;
    font-size: 16px;
    color: #c0c4cc;
    vertical-align: middle;
    cursor: pointer;
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 0;
      padding-right: 0;
      width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
  .s-container {
    margin-top: 24px;
    width: 648px;
    .panel {
      display: inline-block;
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      overflow: hidden;
      vertical-align: top;
      &.panel-left {
        margin-right: 16px;
        width: calc(100% - 216px);
      }
      &.panel-right {
        width: 200px;
      }
      .panel-header {
        padding: 8px 12px;
        border-bottom: 1px solid #e0e0e0;
        background-color: #fafafa;
        color: #333;
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        overflow: hidden;
        .clear {
          float: right;
          font-weight: normal;
          color: #194ce5;
          cursor: pointer;
        }
      }
      .panel-container {
        position: relative;
        height: 192px;
        padding: 6px 0;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }

        ::v-deep  .el-checkbox {
          display: block;
          padding: 7.5px 12px;
          &:hover {
            background-color: #edf1fd;
          }
          .el-checkbox__inner {
            width: 16px;
            height: 16px;
          }
          &.is-checked {
            .el-checkbox__inner {
              background-color: #333;
              border-color: #333;
              &::after {
                left: 5px;
              }
            }
            .el-checkbox__label {
              color: inherit;
            }
          }
          .is-indeterminate {
            .el-checkbox__inner {
              background-color: #333;
              border-color: #333;
            }
          }
        }
        .panel-none {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .item-selected {
          position: relative;
          margin: 8px 12px;
          padding: 2px 8px;
          background-color: #f0f0f0;
          border-radius: 4px;
          .item-name {
            display: block;
            margin-right: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 22px;
            font-size: 14px;
            color: #333;
            font-weight: 400;
            cursor: pointer;
          }
          .el-icon-close {
            position: absolute;
            right: 8px;
            top: 12px;
            line-height: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
  .save-directional {
    margin-top: 28px;
    .s-btn {
      display: inline-block;
      padding: 5px 16px;
      font-size: 14px;
      line-height: 22px;
      border-radius: 4px;
      color: #333;
      background-color: #fff;
      border: solid 1px #999;
      user-select: none;
      cursor: pointer;
      &:hover {
        background-color: #edf1fd;
        border-color: #194ce5;
      }
    }
    p {
      margin-top: 4px;
      font-size: 12px;
      line-height: 22px;
      color: #666;
    }
  }
}
</style>